import * as types from '../constants';
import { STATUS } from '../constants';
import { reject, resolve } from '../api';

export const initialPlaybooksState = {
  playbooksStatus: STATUS.IDLE,
  playbooksSettings: [],
};

export default (state = initialPlaybooksState, action) => {
  switch (action?.type) {
    case types.LOAD_PLAYBOOKS: {
      return {
        ...state,
        playbooksStatus: STATUS.LOADING,
      };
    }
    case resolve(types?.LOAD_PLAYBOOKS): {
      return {
        ...state,
        playbooksSettings: action?.payload?.results,
        playbooksStatus: STATUS.LOADED,
      };
    }
    case reject(types.LOAD_PLAYBOOKS):
      return {
        ...state,
        error: true,
        playbooksStatus: STATUS.ERROR,
      };

    case types.LOAD_PLAYBOOKS_LOGS: {
      return {
        ...state,
        playbooksLogsStatus: STATUS.LOADING,
      };
    }
    case resolve(types.LOAD_PLAYBOOKS_LOGS): {
      return {
        ...state,
        playbooksLogs: action?.payload?.results,
        playbooksLogsStatus: STATUS.LOADED,
      };
    }
    case reject(types.LOAD_PLAYBOOKS_LOGS):
      return {
        ...state,
        error: true,
        playbooksLogsStatus: STATUS.ERROR,
      };

    case types.UPDATE_PLAYBOOKS: {
      const playbook = action?.data;

      const index = state?.playbooksSettings?.findIndex(
        (p) => p?.uuid === playbook?.uuid,
      );
      if (index < 0) return state;
      return {
        ...state,
        playbooksStatus: STATUS.LOADING,
        playbooksSettings: [
          ...state?.playbooksSettings?.slice(0, index),
          { ...playbook },
          ...state?.playbooksSettings?.slice(index + 1),
        ],
      };
    }

    case resolve(types.UPDATE_PLAYBOOKS): {
      // const integration = action.data;
      //console.log('i', integration);
      const playbook = action?.payload;
      const index = state?.playbooksSettings?.findIndex(
        (p) => p?.uuid === action?.payload?.uuid,
      );
      if (index < 0) return state;
      return {
        ...state,
        playbooksStatus: STATUS.LOADED,
        playbooksSettings: [
          ...state?.playbooksSettings?.slice(0, index),
          { ...playbook },
          ...state?.playbooksSettings?.slice(index + 1),
        ],
      };

      // return {
      //   ...state,
      //   //playbooksSettings: action.payload,
      //   playbooksStatus: STATUS.LOADED,
      // };
    }
    case reject(types?.UPDATE_PLAYBOOKS):
      return {
        ...state,
        error: true,
        playbooksStatus: STATUS.ERROR,
      };
    case types.SAVE_PLAYBOOKS: {
      return {
        ...state,
        playbooksStatus: STATUS.LOADING,
      };
    }
    case resolve(types.SAVE_PLAYBOOKS): {
      return {
        ...state,
        playbooksSettings: [...state?.playbooksSettings, action?.payload],
        playbooksStatus: STATUS.LOADED,
      };
    }
    case reject(types.SAVE_PLAYBOOKS):
      return {
        ...state,
        error: true,
        playbooksStatus: STATUS.ERROR,
      };

    case types.DELETE_PLAYBOOKS: {
      const index = state?.playbooksSettings?.findIndex(
        (p) => p?.uuid === action?.uuid,
      );

      return {
        ...state,
        playbooksSettings: [
          ...state?.playbooksSettings?.slice(0, index),
          ...state?.playbooksSettings?.slice(index + 1),
        ],
        playbooksStatus: STATUS.LOADING,
      };
    }
    case resolve(types.DELETE_PLAYBOOKS): {
      return {
        ...state,
        playbooksStatus: STATUS.LOADED,
      };
    }
    case reject(types.DELETE_PLAYBOOKS):
      return {
        ...state,
        error: true,
        playbooksStatus: STATUS.ERROR,
      };

    case resolve(types.RUN_PLAYBOOKS): {
      return {
        ...state,
        //playbooksSettings: action.payload.results,
        playbooksStatus: STATUS.LOADED,
      };
    }
    case reject(types.RUN_PLAYBOOKS):
      return {
        ...state,
        error: true,
        playbooksStatus: STATUS.ERROR,
      };

    default:
      return state;
  }
};
